import { useMembersLogic } from "@hooks/common/members/use-members";
import { createContext, useContext, type PropsWithChildren } from "react";

const MembersContext = createContext<ReturnType<typeof useMembersLogic> | null>(null);

export const MembersProvider = ({ children }: PropsWithChildren) => {
  const membersLogic = useMembersLogic();
  return (
    <MembersContext.Provider value={membersLogic}>
      {children}
    </MembersContext.Provider>
  );
};

export const useMembers = () => {
  const context = useContext(MembersContext);
  if (!context) {
    throw new Error("useMembers must be used within a MembersProvider");
  }
  return context;
};